module.exports = __webpack_public_path__ + "static/media/beach2382.b6b98a8d.jpg";